export const translations = {
  fr: {
    home: "Accueil",
    projects: "Projets",
    about: "À propos",
    contact: "Contact",
    artificialIntelligence: "Intelligence Artificielle",
    industrialDesign: "Design Industriel",
    graphicDesign: "Design Graphique",
    creativeLab: "Laboratoire Créatif",
    legalMentions: "Mentions légales",
    system: "Système",
    contactForm: {
      title: "Contactez-nous",
      namePlaceholder: "Nom",
      firstnamePlaceholder: "Prénom",
      telPlaceholder: "Votre numéro de téléphone",
      emailPlaceholder: "Votre email",
      messagePlaceholder: "Votre message (500 caractères max)",
      sendButton: "Envoyer",
      successMessage: "Votre message a bien été envoyé !",
      errorMessage: "Erreur lors de l'envoi du message.",
      connectionError: "Erreur de connexion au serveur.",
      sending: "Envoi en cours...",
    },
    page404Message: "Oups ! La page que vous cherchez n'existe pas.",
    goBackHome: "Retourner à l'accueil",
    pcw: "Réalisé par",
    mentions: "Mentions Légales",
    politique: "Politique de confidentialité",
    aboutTitle: "À propos de Kim-Anh Atelier",
    aboutDescription: `Bienvenue chez Kim-Anh Atelier, un espace créatif où l’art, la technologie et l’émotion se rencontrent.

Kim-Anh Atelier est un atelier spécialisé dans la création graphique, le design visuel sur-mesure et l’incrustation intelligente avec l’intelligence artificielle.

Chaque projet est conçu avec soin pour sublimer les idées et leur donner une dimension unique, alliant sensibilité artistique et innovations technologiques.

Nous mettons un point d’honneur à offrir des créations esthétiques, modernes et percutantes, qu'il s'agisse de visuels pour le web, de supports imprimés ou de contenus enrichis grâce à l'IA.

Au cœur de notre démarche : la passion, la précision et l’exploration des nouvelles technologies. Nous croyons que l'intelligence artificielle, bien maîtrisée, est un véritable levier pour repousser les limites de la création.`,
    legalPage: {
      title: "Mentions Légales",
      editorTitle: "Éditeur du site",
      editorContent: `Nom de l’entreprise : Point Commun Web
Adresse : 15 rue de Rennes, 56660 Saint-Jean-Brévelay
Téléphone : 07 81 97 43 94
Email : pointcommun.web@gmail.com
Numéro SIRET : 93855835000014
Responsable de publication : Nicolas Péresse`,
      hostingTitle: "Hébergement",
      hostingContent: `Hébergeur : OVH
Adresse : 2 rue Kellermann, 59100 Roubaix, France
Téléphone : 1007`,
      intellectualPropertyTitle: "Propriété intellectuelle",
      intellectualPropertyContent:
        "Tous les contenus présents sur ce site (textes, images, vidéos, etc.) sont protégés par le droit d’auteur. Toute reproduction sans autorisation est interdite.",
      liabilityTitle: "Responsabilité",
      liabilityContent:
        "L’éditeur du site ne saurait être tenu responsable des erreurs ou omissions dans les informations diffusées. L’utilisateur est seul responsable de l’utilisation qu’il fait du contenu du site.",
      personalDataTitle: "Données personnelles",
      personalDataContent: `Ce site collecte des données via son formulaire de contact. Pour en savoir plus, consultez notre `,
      privacyPolicyLink: "Politique de confidentialité",
    },
    privacyPolicyPage: {
    title: "Politique de Confidentialité",
    dataCollectionTitle: "Collecte des données personnelles",
    dataCollectionContent: `Nous collectons vos données personnelles via notre formulaire de contact.
Les informations demandées sont les suivantes : `,
    collectedData: "nom, prénom, adresse, email et numéro de téléphone.",
    dataUsageTitle: "Utilisation des données",
    dataUsageContent: "Ces données sont utilisées uniquement pour répondre à vos demandes de contact et améliorer nos services. ",
    dataUsageNote: "Elles ne sont jamais vendues à des tiers.",
    retentionTitle: "Durée de conservation",
    retentionContent: "Vos données sont conservées pour une durée maximale de ",
    retentionDuration: "12 mois",
    retentionEnd: " après le dernier échange.",
    dataSharingTitle: "Partage des données",
    dataSharingContent: "Vos informations ne sont partagées avec aucun tiers, sauf en cas d’obligation légale.",
    yourRightsTitle: "Vos droits",
    yourRightsIntro: "Conformément au RGPD, vous disposez des droits suivants :",
    yourRightsList: [
      "Accéder à vos données.",
      "Rectifier vos données.",
      "Demander la suppression de vos données.",
    ],
    yourRightsContact: "Pour exercer ces droits, contactez-nous à : ",
    securityTitle: "Sécurité",
    securityContent: "Nous mettons en place des mesures de sécurité pour protéger vos informations personnelles contre tout accès non autorisé.",
    contactTitle: "Contact",
    contactContent: "Pour toute question concernant cette politique, contactez-nous à : ",
    contactEmail: "laura.peresse@gmail.com",
  },
  },
  en: {
    home: "Home",
    projects: "Projects",
    about: "About",
    contact: "Contact",
    artificialIntelligence: "Artificial Intelligence",
    industrialDesign: "Industrial Design",
    graphicDesign: "Graphic Design",
    creativeLab: "Creative Lab",
    legalMentions: "Legal Mentions",
    system: "System",
    contactForm: {
      title: "Contact Us",
      namePlaceholder: "Name",
      firstnamePlaceholder: "First Name",
      telPlaceholder: "Your Phone Number",
      emailPlaceholder: "Your Email",
      messagePlaceholder: "Your message (500 characters max)",
      sendButton: "Send",
      successMessage: "Your message has been sent!",
      errorMessage: "Error sending the message.",
      connectionError: "Connection error to the server.",
      sending: "Sending...",
    },
    page404Message: "Oops! The page you're looking for doesn't exist.",
    goBackHome: "Go back to Home",
    pcw: "Made by",
    mentions: "Legal Notices",
    politique: "Privacy Policy",
    aboutTitle: "About Kim-Anh Atelier",
    aboutDescription: `Welcome to Kim-Anh Atelier, a creative space where art, technology, and emotion come together.

Kim-Anh Atelier specializes in graphic design, custom visual creations, and intelligent integration using artificial intelligence.

Each project is carefully crafted to elevate ideas and give them a unique dimension, combining artistic sensitivity with technological innovation.

We take pride in delivering aesthetic, modern, and impactful creations, whether for web visuals, printed materials, or AI-enhanced content.

At the heart of our work: passion, precision, and the exploration of new technologies. We believe that when mastered, artificial intelligence is a true catalyst for pushing the boundaries of creativity.`,
    legalPage: {
      title: "Legal Mentions",
      editorTitle: "Site Publisher",
      editorContent: `Company Name: Point Commun Web
Address: 15 rue de Rennes, 56660 Saint-Jean-Brévelay
Phone: 07 81 97 43 94
Email: pointcommun.web@gmail.com
SIRET Number: 93855835000014
Publication Director: Nicolas Péresse`,
      hostingTitle: "Hosting",
      hostingContent: `Host: OVH
Address: 2 rue Kellermann, 59100 Roubaix, France
Phone: 1007`,
      intellectualPropertyTitle: "Intellectual Property",
      intellectualPropertyContent:
        "All content on this site (texts, images, videos, etc.) is protected by copyright. Any reproduction without authorization is prohibited.",
      liabilityTitle: "Liability",
      liabilityContent:
        "The site publisher cannot be held responsible for errors or omissions in the information provided. The user is solely responsible for how they use the site's content.",
      personalDataTitle: "Personal Data",
      personalDataContent: `This site collects data via its contact form. To learn more, please see our `,
      privacyPolicyLink: "Privacy Policy",
    },
     privacyPolicyPage: {
    title: "Privacy Policy",
    dataCollectionTitle: "Collection of Personal Data",
    dataCollectionContent: `We collect your personal data through our contact form.
The requested information includes: `,
    collectedData: "name, first name, address, email, and phone number.",
    dataUsageTitle: "Use of Data",
    dataUsageContent: "This data is used solely to respond to your contact requests and to improve our services. ",
    dataUsageNote: "It is never sold to third parties.",
    retentionTitle: "Data Retention Period",
    retentionContent: "Your data is retained for a maximum of ",
    retentionDuration: "12 months",
    retentionEnd: " after the last exchange.",
    dataSharingTitle: "Data Sharing",
    dataSharingContent: "Your information is not shared with any third parties, except in cases of legal obligation.",
    yourRightsTitle: "Your Rights",
    yourRightsIntro: "In accordance with the GDPR, you have the following rights:",
    yourRightsList: [
      "Access your data.",
      "Rectify your data.",
      "Request the deletion of your data.",
    ],
    yourRightsContact: "To exercise these rights, contact us at: ",
    securityTitle: "Security",
    securityContent: "We implement security measures to protect your personal information against unauthorized access.",
    contactTitle: "Contact",
    contactContent: "For any questions regarding this policy, contact us at: ",
    contactEmail: "laura.peresse@gmail.com",
  },
  },
};
